import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { ServicePlanItemPricingPolicy } from 'src/features/servicePlanPricingPolicies/utils/types';
import { ServicePlanPricingPolicyPayload } from 'src/features/servicePlanPricingPolicies/utils/formSchema';

const RESOURCE = '/subscriptions/service-plan-item/:servicePlanItemId/service-plan-item-pricing-policy/';

type MutationFnType = typeof mutationFn;

interface DTO extends ServicePlanPricingPolicyPayload {
    servicePlanItemId: string;
}

const mutationFn = ({ servicePlanItemId, ...data }: DTO): Promise<ServicePlanItemPricingPolicy> => {
    return axios.post(formatResourcePath(RESOURCE, { servicePlanItemId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateServicePlanPricingPolicy };
